import { render, staticRenderFns } from "./SpecialButton.vue?vue&type=template&id=b7b7480e&"
import script from "./SpecialButton.vue?vue&type=script&lang=js&"
export * from "./SpecialButton.vue?vue&type=script&lang=js&"
import style0 from "./SpecialButton.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports